export const CLEARMENT_TITLE = 'Clearment.ai Vertragsschutz'
export const CLEARMENT_DESCRIPTION = 'Clearment.ai Vertragsschutz'

